interface Section {
  name: string;
  displayName: string;
}

export const getCategoriesNames = (categories: string[], sections: Section[]): string => {
  const filteredSections = sections.filter(section => categories.includes(section.name));
  return filteredSections.map(section => section.displayName).join(', ');
};
